import { render, staticRenderFns } from "./FrontProviderLayout.vue?vue&type=template&id=2de3d8a8&scoped=true&"
import script from "./FrontProviderLayout.vue?vue&type=script&lang=js&"
export * from "./FrontProviderLayout.vue?vue&type=script&lang=js&"
import style0 from "./FrontProviderLayout.vue?vue&type=style&index=0&id=2de3d8a8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de3d8a8",
  null
  
)

export default component.exports